export default function PageFilter({children}){
    return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
            {children}
        </div>
    );
}